module.exports = __webpack_public_path__ + "img/制御工学5_8_1.6677b057.png";